import { useEffect, useRef, useState } from "react";
import html from "../../components/ContentHtml/config";

export default function useLectureProgress(courseSlug, lectureSlug, allowToggle = false, title = "") {
  const [completed, setCompleted] = useState(false);
  const [progress, setProgress] = useState({})
  const startTimeRef = useRef(Date.now());

  const PROGRESS_ENABLED = false; //disable after API setup

  
  const API_URL = window.location.hostname === "localhost"
    ?  "http://localhost:4000/api"
    : process.env.REACT_APP_API_URL
 
    useEffect(() => {  // disable after API setup
      if (!PROGRESS_ENABLED) return;

      const fetchProgress = async () => {
        try {
          const res = await fetch(`/api/progress/${courseSlug}`);
          if (!res.ok) return;
          const data = await res.json();
          setProgress(data);
        } catch (err) {
          console.log("Progress disabled (backend not ready)");
        }
      };

      fetchProgress();
    }, [courseSlug]);


      
  useEffect(() => {
  if (!lectureSlug || !courseSlug) return;

  const fetchProgress = () => {
    fetch(`${API_URL}/progress/me/${courseSlug}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}`
  }
    })
      .then(res => res.json())
      .then(data => {
        const lesson = data.progress.find(
          p => p.lessonSlug === lectureSlug
        );
        setCompleted(lesson?.status === "completed");
      });
  };

  fetchProgress();

  window.addEventListener("lectureProgressUpdated", fetchProgress);

  return () => {
    window.removeEventListener("lectureProgressUpdated", fetchProgress);
  };
}, [lectureSlug, courseSlug]);

//Send the time spent when leaving the page
  // useEffect(() => {
  //   const startTime = startTimeRef.current;

  //   return () => {
  //     const diff = Math.floor((Date.now() - startTime) / 1000);
  //     const study = Math.min(diff, 10800);

  //     fetch(`${API_URL}/progress/time`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`
  //       },
  //       body: JSON.stringify({
  //         lectureSlug,
  //         seconds: study
  //       })
  //     });
  //   };
  // }, [lectureSlug]);

  const toggleComplete = async () => {
    if (!allowToggle) return;
    console.log("🚀 SENDING TO SERVER:", {courseSlug, lessonSlug: lectureSlug, title});

      try {
        const res = await fetch(`${API_URL}/progress`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify({
            courseSlug,
            lessonSlug: lectureSlug,
            lessonType: "text",
            title,
            secondsSpent: 999
          })
        });

        const data = await res.json();
        console.log("✅ RESPONSE FROM DB:", data);
        const newStatus = data.status === "completed";
        setCompleted(newStatus); 
        window.dispatchEvent(new CustomEvent("lectureProgressUpdated"));

        return newStatus;

      } catch (err) {
      console.error("Toggle failed", err);
    }
  };
  
  return { completed, toggleComplete };
};
